import {omitBy, isNaN, every, isUndefined} from 'lodash';

export const getPageConfigFromNginx = req =>
  omitBy({
    hostname: req.get('R29-HOSTNAME'),
    edition_id: parseInt(req.get('R29-EDITIONID')),
    site: req.get('R29-SITE'),
    type: req.get('R29-TYPE'),
    type_id: parseInt(req.get('R29-TYPEID')),
    isPreview: req.get('R29-ISPREVIEW') === 'true'
  }, value => isUndefined(value) || isNaN(value));

export const pageConfigIsValid = pageConfig => {
  const keysToCheck = pageConfig.isPreview
    ? ['hostname', 'site', 'isPreview']
    : ['hostname', 'site', 'type', 'type_id', 'isPreview'];
  return every(keysToCheck, key => !isUndefined(pageConfig[key]));
};
